import { captureException } from '@sentry/browser';
import { Barcode } from './barcode';
import { BarcodeType } from './types/barcode.type';
import { UniqueHtmlElement } from './unique-html-element';

export class BarcodePreviewHandler extends UniqueHtmlElement<HTMLElement> {
  private svgElement!: SVGElement;

  constructor(selector: string) {
    super(selector);

    const svgElement = this.element?.querySelector<SVGElement>('svg.barcode');

    if (!svgElement) {
      throw new Error('unable to find svg element');
    }

    this.svgElement = svgElement;
  }

  async renderPreview(
    barcodeType: BarcodeType,
    rangeStart: number,
    additionalText: string,
    barcodeTemplatePrefix: string,
    barcodeTemplateSuffix: string,
  ) {
    try {
      const barcode = new Barcode(
        `${barcodeTemplatePrefix}${rangeStart}${barcodeTemplateSuffix}`,
        additionalText,
        this.svgElement,
      );

      await barcode.renderSvg(barcodeType);

      UniqueHtmlElement.hide(this.element?.querySelector('.error'));
      UniqueHtmlElement.show(this.svgElement);
    } catch (e) {
      console.error(e);
      captureException(e, {
        extra: {
          feedback: 'no',
          barcodeType,
          rangeStart,
          additionalText,
          barcodeTemplatePrefix,
          barcodeTemplateSuffix,
        },
      });

      UniqueHtmlElement.hide(this.svgElement);
      UniqueHtmlElement.show(this.element?.querySelector('.error'));
    }
  }
}
